/* eslint-disable no-restricted-globals */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { Cancel, Delete, Edit, Save } from '@mui/icons-material';
import { Checkbox, FormControlLabel, withStyles } from '@material-ui/core';
import { MaterialReactTable } from 'material-react-table';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { formatDateForInput } from 'utilities/common';
import { formatMoney } from 'utilities/currencyFormatter';
import { useMoneyInputs } from 'modules/common/useMoneyInputs';
import { showToast } from 'modules/layout/layout.actions';
import AdvancedSearch from 'modules/common/advancedSearch.component';
import React, { useCallback, useEffect, useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import countries from 'modules/common/countries.json';
import states from 'modules/common/states.json';
import { memoize } from 'lodash';
import { getDependentOptions, setValueAndClearDependents } from 'modules/common/utils';
import MultiRowForm from 'modules/common/multiRowForm.component';
import GoogleAddressSearch from 'modules/common/googleAddressSearch.component';
import { useEnumColumnData } from 'modules/common/enumTableColumn';

const styles = theme => ({
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  }
});

/*
    - Required Props: 
     * editingMode (must be 'row' or 'modal')
     * columns
     * rows
    - Optional Props: 
     * updateRow (typically an API PUT call followed by GET call to refresh the data, returns boolean) 
     * createRow (typically an API POST call followed by GET call to refresh the data, returns boolean) 
     * deleteRow (typically an API DELETE call followed by GET call to refresh the data, returns boolean) 
     * customValidator (function that must return boolean)
     * initialState (the initial state of the table - used to hide columns for example)
     * hideEdit (removes all editing/adding functionality to rows)
     * toolbarCustomButton (a custom button displayed next to the 'add' button )
     * customButtonText (custom text on the toolbar custom button)
     * customButtonMethod (custom method for what the custom button in the table does)
     * actionsColumnSize (size of the row actions column, default 50; columns stretch in proportion to their sizes, so give
       the data columns realistic sizes too when setting this)
     * fixedColumnWidths (default false; true sizes the table to the sum of its column sizes, so columns keep exactly their
       sizes instead of stretching to fill the card, and resizing one column leaves the others alone. The table scrolls
       horizontally when it is wider than the card. Give columns a minSize that fits their header.)

    - Required Column Fields: accessorKey, header, type, options (only required for dropdown type)
    - Optional Column Fields: required (defaults to false), size, enableColumnOrdering, enableEditing, enableSorting, hideInTable (if column should be displayed in the CRUD table or not)
     * computeValue (values => value; derives the field from the modal's other values and recalculates it as they change.
       Pair it with disabled: true, and don't read the field's own value inside it.)

    - Column Types: text, number, date, dropdown, notes, checkbox, dropdown-v2, multi-select, multi-select-v2, dropdown-bool (FOR OPTIONS, TRUE VALUE MUST ALWAYS BE FIRST)

    USING THE CRUD TABLE DYNAMICALLY:

    You MUST declare a list of categories to display.

    categories - a list of 'sections' for data to be placed into, which can appear dynamically/not
    ex.  const categories = [
      { id: 0, title: 'tripSummary',}, { id: 1, title: 'airTransport', conditionalRender: 'airTransport'}, { id: 2, title: 'hotelBooking', conditionalRender: 'hotelBooking'}, { id: 3, title: 'rentalCarBooking', conditionalRender: 'rentalCarBooking'}];
      id - index position
      title - the title of the category
      conditionalRender - the accessorkey of the value that conditionally renders that category if it exists. MUST BE A TRUE/FALSE VALUE ONLY!

    Within COLUMNS:
      categoryType: the name of the category a field belongs to (required for all fields if using categories)
      dependentOn: the accessorkey of the field one is dependent on to be displayed. Use if a field being displayed is dependent on a different field value that is NOT TRUE OR FALSE (for a single field ONLY)
      dependentValue: the value of the field one is dependent on to be displayed. Use if NOT TRUE OR FALSE and for a SINGLE FIELD

*/

const chunkColumns = (columns, chunkSize) => {
  const rows = [];
  for (let i = 0; i < columns.length; i += chunkSize) {
    rows.push(columns.slice(i, i + chunkSize));
  }
  return rows;
};

// Keeps every column with a computeValue in step with the rest of a modal's values.
const useComputedColumnValues = (columns, values, setValues) => {
  useEffect(() => {
    const staleColumns = columns.filter(
      column => typeof column.computeValue === 'function' && !Object.is(column.computeValue(values), values[column.accessorKey]),
    );
    if (!staleColumns.length) return;

    setValues(current =>
      staleColumns.reduce((next, column) => ({ ...next, [column.accessorKey]: column.computeValue(current) }), current),
    );
  }, [columns, values, setValues]);
};

const getMissingRequiredFields = (columns, values, categories) =>
  columns
    .filter(column => {
      if (!column.required || column.hideInModel || column.type === 'hidden' || column.shouldHideField?.(values)) return false;
      if (column.displayDependent) {
        const expected = column.displayDependentVal;
        if (!((Array.isArray(expected) && expected.includes(values[column.displayDependent])) ||
          values[column.displayDependent] === expected || values[column.displayDependent] === true)) return false;
      }
      if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) return false;
      const category = categories?.find(item => item.title === column.categoryType);
      if (category?.conditionalRender && values[column.categoryType] !== true && !column.conditional) return false;
      return true;
    })
    .filter(column => {
      const value = values[column.accessorKey];
      return value === null || value === undefined || (typeof value === 'string' && !value.trim()) ||
        (Array.isArray(value) && value.length === 0);
    })
    .map(column => column.header);

const CrudTable = ({
  editingMode,
  classes,
  columns,
  rows,
  updateRow,
  createRow,
  deleteRow,
  customValidator,
  showToast,
  customAddText,
  isLoading = false,
  getNameOfDeleteRow = null,
  hideEdit,
  toolbarCustomButton,
  customButtonText,
  customButtonMethod,
  showBasicTable = false,
  headerRowFields = null,
  pinnedRow = null,
  categories = null,
  hideAdd = false,
  hideDelete = false,
  actionsColumnSize = 50,
  fixedColumnWidths = false,
  onRowClick,
  enableRowHoverHighlight = false,
  rowHoverColor = '#f5f5f5',
  isDirtyLogic = null,
  isDirtyField = null,
  customCreateColumns = null
}) => {

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState(() => rows);
  const [validationErrors, setValidationErrors] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [editingRowModalOpen, setEditingModalOpen] = useState(false);
  const createColumns = customCreateColumns && customCreateColumns.length > 0 ? customCreateColumns : columns;

  const getCommonEditTextFieldProps = useCallback(
    cell => {
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: event => {
          const requiredIsEmpty = cell.column.columnDef.required && event.target.value.length === 0;
          const isValid = customValidator ? customValidator(cell, event.target.value) : true;
          if (!isValid || requiredIsEmpty) {
            //set validation error for cell if invalid
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is missing or incorrectly formatted.`
            });
          } else {
            //remove validation error for cell if valid
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors
            });
          }
        }
      };
    },
    [validationErrors]
  );

  // creation of the editing modal text fields
  columns.forEach(col => {
    if (col.type === 'text') {
      if (!col.size) col.size = 50;
      col.muiTableBodyCellEditTextFieldProps = ({ cell }) => ({
        ...getCommonEditTextFieldProps(cell)
      });
    } else if (col.type === 'email') {
      col.muiTableBodyCellEditTextFieldProps = ({ cell }) => ({
        ...getCommonEditTextFieldProps(cell),
        type: 'email'
      });
    } else if (col.type === 'number') {
      col.muiTableBodyCellEditTextFieldProps = ({ cell }) => ({
        ...getCommonEditTextFieldProps(cell),
        type: 'number'
      });
    } else if (col.type === 'money') {
      // Grid display only; columns with their own Cell keep it, and edit inputs still hold the raw number.
      if (!col.Cell) col.Cell = ({ cell }) => formatMoney(cell.getValue());
    } else if (col.type === 'date') {
      col.muiTableBodyCellEditTextFieldProps = ({ cell }) => ({
        ...getCommonEditTextFieldProps(cell),
        type: 'date'
      });
    } else if (col.type === 'dropdown') {
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: col.options.map(opt => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))
      };
    } else if (col.type === 'dropdown-v2') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: col.options.map(opt => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.description}
          </MenuItem>
        ))
      };
    } else if (col.type === 'country') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: countries.map(opt => (
          <MenuItem key={opt.countryCode} value={opt.countryCode}>
            {opt.description}
          </MenuItem>
        ))
      };
    } else if (col.type === 'state') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: states.map(opt => (
          <MenuItem key={opt.code} value={opt.code}>
            {opt.description}
          </MenuItem>
        ))
      };
    } else if (col.type === 'multi-select') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: col.options.map(opt => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.description}
          </MenuItem>
        )),
      };
    } else if (col.type === 'country') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: countries.map((opt) => (
          <MenuItem key={opt.countryCode} value={opt.countryCode}>
            {opt.description}
          </MenuItem>
        )),
      };
    } else if (col.type === 'state') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: states.map((opt) => (
          <MenuItem key={opt.code} value={opt.code}>
            {opt.description}
          </MenuItem>
        )),
      };
    }  else if (col.type === 'multi-select') {
      col.editSelectOptions = col.options;
      col.muiTableBodyCellEditTextFieldProps = {
        select: true,
        children: col.options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.title}
          </MenuItem>
        ))
      };
    } else if (col.type === 'multi-select-v2') {
      return col.value && Array.isArray(col.value) && col.value.length > 0 ? (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px'
          }}
        >
          {col.value.map((value, index) => (
            <Chip key={index} label={value.title} sx={{ margin: '2px' }} />
          ))}
        </div>
      ) : (
        <div>&mdash;</div>
      );
    }
    else if (col.type === 'multi-select-v2') {
          return col.value && Array.isArray(col.value) && col.value.length > 0 ? (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4px'
              }}
            >
              {col.value.map((value, index) => (
                <Chip key={index} label={value.title} sx={{ margin: '2px' }} />
              ))}
            </div>
          ) : (
            <div>&mdash;</div>
          );
        }
  });

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const handleCreateNewRow = async values => {
    const missingFields = getMissingRequiredFields(createColumns, values, categories);
    if (missingFields.length) {
      showToast(`Please fill out the required fields: ${missingFields.join(', ')}.`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }

    // Send POST call to parent to update and refresh values.
    if (createRow) {
      const resp = await createRow(values);
      if (!resp) {
        showToast('Failed to update table data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
      }
    }
    return true;
  };

  const handleSaveRowEdits = async (exitEditingMode, row, values) => {
    const missingFields = getMissingRequiredFields(columns, values, categories);
    if (missingFields.length) {
      showToast(`Please fill out the required fields: ${missingFields.join(', ')}.`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }

    if (Object.keys(validationErrors).length) {
      showToast('Please correct the highlighted fields before saving.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }

    let updatedRow = { ...row.original, ...values };

    // Send update call to parent to update and refresh values.
    if (updateRow) {
      const resp = await updateRow(row, values);
      if (!resp) {
        showToast('Failed to update table data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }

      if (resp?.hasContent === true) {
        updatedRow = { ...updatedRow, ...resp.content };
      }
    }

    setTableData(currentData => currentData.map((item, index) => index === row.index ? updatedRow : item));
    exitEditingMode(); //required to exit editing mode and close modal
  };

  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  const hideColumns = columns => {
    let hiddenCols = {};
    columns.map(col => {
      if (col.hideInTable) {
        hiddenCols[col.accessorKey] = false;
      }
    });
    return hiddenCols;
  };

  const handleDeleteRow = useCallback(
    async row => {
      let nameOfDeleteRow = getNameOfDeleteRow === null ? row.getValue(columns[0].accessorKey) : getNameOfDeleteRow(row);
      if (!confirm(`Are you sure you want to delete ${nameOfDeleteRow}?`)) {
        return;
      }
      // Send update call to parent to update and refresh values.
      if (deleteRow) {
        const resp = await deleteRow(row);
        if (!resp) {
          showToast('Failed to update table data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return;
        }
      }
      tableData.splice(row.index, 1);
      setTableData([...tableData]);
    },
    [tableData]
  );

  const renderValue = (type, value, rowField) => {
    if (type === 'money') {
      return value ? formatMoney(value) : <div>&mdash;</div>;
    } else if (type === 'googleAddressSearch') {
      return rowField && value ? value[rowField.displayValue] : <div>&mdash;</div>;
    } else if (type === 'advanced-search') {
      return rowField && value ? value[rowField.nameValue] : <div>&mdash;</div>;
    }
    else {
      return value ? value : <div>&mdash;</div>;
    }
  };

  const renderHeaderRowFields = rowField => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ marginBottom: '4px', marginRight: '16px' }}>
          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
            {rowField.fieldHeader}
          </Typography>
        </Box>
        <Box sx={{ marginBottom: '4px', marginRight: '16px' }}>
          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
            {renderValue(rowField.fieldType, rowField.fieldValue, rowField)}
          </Typography>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    setTableData(rows);
  }, [rows]);

  const data = useEnumColumnData(tableData, columns);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          margin: 1,
          overflow: 'hidden'
        }}
      >
        <MaterialReactTable
          displayColumnDefOptions={{
            'mrt-row-actions': {
              muiTableHeadCellProps: {
                align: 'center'
              },
              size: actionsColumnSize,
              minSize: 50
            }
          }}
          // With column resizing on, the table uses a fixed layout at 100% width, so any width the columns don't use is
          // spread across all of them. Sizing the table to exactly its columns stops that.
          muiTableProps={fixedColumnWidths ? ({ table }) => ({ sx: { width: `${table.getTotalSize()}px` } }) : undefined}
          columns={columns}
          data={data}
          editingMode={editingMode} //default
          enableColumnOrdering={!showBasicTable}
          enableColumnResizing={!showBasicTable}
          enableColumnFilters={!showBasicTable}
          enableEditing={!hideEdit}
          enableRowActions={true}
          onEditingRowSave={handleSaveRowEdits}
          onEditingRowCancel={handleCancelRowEdits}
          enableColumnActions={!showBasicTable}
          enableGlobalFilter={!showBasicTable}
          enableColumnVisibility={!showBasicTable}
          enableDensityToggle={!showBasicTable}
          enablePinning={!showBasicTable}
          enableFullScreenToggle={!showBasicTable}
          //enableTopToolbar={!showBasicTable}
          enableHiding={!showBasicTable}
          enableColumnFilterModes={!showBasicTable}
          initialState={{ columnVisibility: hideColumns(columns) /* columnFilters: [{ id: 'status', value: 'A' }] */ }} //commented out per Derek because it's causing errors and should be fed into the crud table instead of staticly assigned here
          muiTableBodyRowProps={({ row }) => {
            const isPinned =
              pinnedRow && (row.original[pinnedRow.name] === pinnedRow.valueOne || row.original[pinnedRow.name] === pinnedRow.valueTwo);

            return {
              onClick: () => {
                if (onRowClick) {
                  onRowClick(row);
                }
              },
              sx: {
                cursor: onRowClick ? 'pointer' : 'default',
                backgroundColor: isPinned ? '#edf7ed' : undefined,
                ':hover': {
                  backgroundColor: isPinned ? '#edf7ed' : enableRowHoverHighlight ? rowHoverColor : undefined
                }
              }
            };
          }}
          renderRowActions={({ row, table }) => (
            <>
              {(editingMode === 'modal' || (editingMode === 'row' && row.id !== editingId)) && (
                <Box sx={{ display: 'flex', gap: '1rem' }}>
                  <Tooltip arrow placement="left" title="Edit">
                    <IconButton
                      onClick={() => {
                        setEditingModalOpen(true);
                        setEditingId(row.id);
                        setEditingRow(row);
                      }}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  {!hideEdit && !hideDelete && (
                    <>
                      <Tooltip arrow placement="right" title="Delete">
                        <IconButton color="error" disabled={row.original.deletionDisabled} onClick={() => handleDeleteRow(row)}>
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </Box>
              )}
              {editingMode === 'row' && row.id === editingId && (
                <Box sx={{ display: 'flex', gap: '1rem' }}>
                  <Tooltip arrow placement="right" title="Cancel">
                    <IconButton
                      color="error"
                      onClick={() => {
                        setEditingId(null);
                        table.setEditingRow(null);
                      }}
                    >
                      <Cancel />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow placement="left" title="Save">
                    <IconButton
                      onClick={() => {
                        handleSaveRowEdits({
                          exitEditingMode: () => {
                            setEditingId(null);
                            table.setEditingRow(null);
                          },
                          row,
                          values: table.getState().editingRow._valuesCache
                        });
                      }}
                    >
                      <Save />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </>
          )}
          renderTopToolbarCustomActions={() => (
            <>
              {!hideEdit && !hideAdd && (
                <Button color="primary" onClick={() => setCreateModalOpen(true)} variant="contained">
                  {customAddText ? customAddText : 'Add record'}
                </Button>
              )}
              {toolbarCustomButton && (
                <Button color="primary" onClick={() => customButtonMethod()} variant="contained">
                  {customButtonText ? customButtonText : 'Custom Action'}
                </Button>
              )}
              {headerRowFields && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '40px' }}>{headerRowFields.map(renderHeaderRowFields)}</Box>
              )}
            </>
          )}
        />
      </Box>
      <CreateNewAccountModal
        columns={createColumns}
        classes={classes}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        isLoading={isLoading}
        categories={categories}
        isDirtyLogic={isDirtyLogic}
        isDirtyField={isDirtyField}
      />
      {editingRowModalOpen && (
        <EditRecordModal
          columns={columns}
          classes={classes}
          open={editingRowModalOpen}
          onClose={() => setEditingModalOpen(false)}
          row={editingRow}
          onSubmit={handleSaveRowEdits}
          isLoading={isLoading}
          hideEdit={hideEdit}
          categories={categories}
          isDirtyLogic={isDirtyLogic}
          isDirtyField={isDirtyField}
        />
      )}
    </ThemeProvider>
  );
};

/*
    - 9/8/2023 - How the editing modal works
    - Field Types: 
     * text
     * notes (meant to expand the full width of the editing modal)
     * number
     * checkbox
     * dropdown
    - Column Division:
     * The editing modal is divided into 3 columns, inserting row-by-row in the order the columns are sent in
     * If a field is of type "notes", it will be inserted into a notes section
     * If a field is a: added on, added by, modified on, modified by, it will be inserted into its own section at the bottom of the modal
     * 

*/

//example of creating a mui dialog modal for creating new rows
export const EditRecordModal = ({
  open,
  classes,
  columns,
  onClose,
  row,
  onSubmit,
  hideEdit,
  isLoading,
  categories,
  isDirtyLogic,
  isDirtyField
}) => {
  const moneyInput = useMoneyInputs();
  // Seed from row.original, not row.getValue: an enumColumn's value is its title, while the form edits the id.
  const [values, setValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = row.original[column.accessorKey];
      return acc;
    }, {})
  );

  useComputedColumnValues(columns, values, setValues);

  const [countryCode, setCountryCode] = useState(values && values.length > 0 ? values['country'] : '');

  const parseValueToArray = input => {
    if (!input) return [];
    return Array.isArray(input) ? input : input.split(',');
  };

  const renderStateOptions = memoize(() => {
    const useCountryCode = countryCode || 'USA';
    let allStates = states.filter(state => state.countryCode === useCountryCode).map(state => state);
    return allStates;
  });

  const renderCountryOptions = memoize(() => {
    let allCountries = countries.map(country => country);
    return allCountries;
  });

  const renderInput = column => {
    if (column?.hideInModel === true || (column.shouldHideField != null && column.shouldHideField(values))) {
      return null;
    }

    if (column.type === 'hidden') {
      return <div></div>;
    }
    if (column.type === 'title') {
      return (
        <div style={{ marginBottom: '16px' }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              marginBottom: '8px'
            }}
          >
            {column.header}
          </Typography>
          <Divider sx={{ marginBottom: '16px' }} />
        </div>
      );
    }
    if (column.type === 'text') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey]}
            disabled={column.accessorKey === 'fieldId' ? (values[column.accessorKey] || '').length > 0 : column.disabled}
            margin="dense"
            variant="standard"
            sx={{ width: '360px' }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.hint && (
            <Typography variant="caption" display="block" color="text.secondary" sx={{ marginTop: '4px' }}>
              {column.hint}
            </Typography>
          )}
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'notes') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey]}
            disabled={column.disabled}
            margin="dense"
            multiline
            variant="standard"
            rows={4}
            sx={{ width: '1100px' }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.hint && (
            <Typography variant="caption" display="block" color="text.secondary" sx={{ marginTop: '4px' }}>
              {column.hint}
            </Typography>
          )}
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'number') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey]}
            margin="dense"
            disabled={column.disabled}
            sx={{ width: '360px' }}
            variant="standard"
            type="number"
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'checkbox') {
      return (
        <div>
          <FormControl sx={{ marginTop: '20px', marginBottom: '5px', marginRight: '200px' }}>
            <FormControlLabel
              key={column.accessorKey}
              name={column.accessorKey}
              label={column.header}
              labelPlacement="start"
              control={<Checkbox />}
              required={column.required}
              disabled={column.disabled}
              checked={values[column.accessorKey]}
              variant="standard"
              margin="dense"
              sx={{ marginTop: '6px' }}
              onClick={e => setValues({ ...values, [e.target.name]: e.target.checked })}
            />
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'dropdown') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={values[column.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'dropdown-bool') {
      if (values[column.accessorKey] !== undefined) {
        let convertedValue = '';
        if (values[column.accessorKey] === true) {
          convertedValue = column.options[0];
        } else if (values[column.accessorKey] === false) {
          convertedValue = column.options[1];
        } else {
          convertedValue = values[column.accessorKey];
        }
        return (
          <div>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
                {column.header}
              </InputLabel>
              <Select
                labelId={column.header}
                key={column.accessorKey}
                label={column.header}
                name={column.accessorKey}
                required={column.required}
                disabled={column.disabled}
                value={convertedValue}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
                onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
              >
                {column.options.map(opt => (
                  <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {column.required && (
              <>
                <Typography variant="caption" display="block" color="primary">
                  Required
                </Typography>
              </>
            )}
          </div>
        );
      } else {
        let convertedValue = '';
        if (values[column.accessorKey] === true) {
          convertedValue = column.options[0];
        } else if (values[column.accessorKey] === false) {
          convertedValue = column.options[1];
        } else {
          convertedValue = values[column.accessorKey];
        }
        return (
          <div>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
                {column.header}
              </InputLabel>
              <Select
                labelId={column.header}
                key={column.accessorKey}
                label={column.header}
                name={column.accessorKey}
                required={column.required}
                disabled={column.disabled}
                value={convertedValue}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
                onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
              >
                {column.options.map(opt => (
                  <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {column.required && (
              <>
                <Typography variant="caption" display="block" color="primary">
                  Required
                </Typography>
              </>
            )}
          </div>
        );
      }
    }
    if (column.type === 'googleAddressSearch') {
      return (
        <div>
          <GoogleAddressSearch
            address={values[column.accessorKey]}
            provinces={column.provinces}
            classes={classes}
            countries={column.countries}
            onChange={e => {
              setValues({ ...values, [column.accessorKey]: e });
            }}
          />
        </div>
      );
    }
    if (column.type === 'dropdown-bool') {
      if(values[column.accessorKey] !== undefined)
      {
        let convertedValue = '';
        if(values[column.accessorKey] === true)
        {
          convertedValue = column.options[0];
        }
        else if(values[column.accessorKey] === false)
        {
          convertedValue = column.options[1];
        }
        else {
          convertedValue = values[column.accessorKey];
        }
        return (
          <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={convertedValue}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
        );
      }
      else {
        let convertedValue = '';
        if(values[column.accessorKey] === true)
        {
          convertedValue = column.options[0];
        }
        else if(values[column.accessorKey] === false)
        {
          convertedValue = column.options[1];
        }
        else {
          convertedValue = values[column.accessorKey];
        }
        return (
          <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={convertedValue}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
        );
      }
      
    }
    if(column.type === 'googleAddressSearch') {
          return (  
            <div>
              <GoogleAddressSearch 
                address={values[column.accessorKey]}
                provinces={column.provinces}
                classes={classes}
                countries={column.countries}
                onChange={e => {
                  setValues({ ...values, [column.accessorKey]: e });
                }}
              />
            </div>
          )
        }
    if (column.type === 'dropdown-v2') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled || (!!column.parentField && !values[column.parentField])}
              value={values[column.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => setValues(setValueAndClearDependents(columns, values, e.target.name, e.target.value))}
            >
              {getDependentOptions(column, values).map(opt => (
                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'country') {
      let countryOptions = renderCountryOptions();
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={values[column.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => {
                setValues({ ...values, [e.target.name]: e.target.value });
                setCountryCode(values['country']);
              }}
            >
              {countryOptions.map(opt => (
                <MenuItem key={opt.countryCode} value={opt.countryCode} sx={{ margin: 'dense' }}>
                  {opt.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'state') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={values[column.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {renderStateOptions().map(opt => (
                <MenuItem key={opt.code} value={opt.code} sx={{ margin: 'dense' }}>
                  {opt.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-select') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={parseValueToArray(values[column.accessorKey])}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(value => (
                    <Chip
                      key={value}
                      label={value}
                      onDelete={() => {
                        const updatedValues = parseValueToArray(values[column.accessorKey]).filter(v => v !== value);
                        setValues({ ...values, [column.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-select-v2') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={parseValueToArray(values[column.accessorKey])}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(value => (
                    <Chip
                      key={value.id}
                      label={value.title}
                      onDelete={() => {
                        const updatedValues = parseValueToArray(values[column.accessorKey]).filter(v => v.id !== value.id);
                        setValues({ ...values, [column.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt.id} value={opt} sx={{ margin: 'dense' }}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'date') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            disabled={column.disabled}
            value={formatDateForInput(values[column.accessorKey])}
            sx={{ width: '360px' }}
            margin="dense"
            variant="standard"
            type="date"
            InputLabelProps={{ shrink: true }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'money') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            {...moneyInput(column.accessorKey, values[column.accessorKey], e =>
              setValues({ ...values, [e.target.name]: e.target.value }),
            )}
            margin="dense"
            disabled={column.disabled}
            sx={{ maxWidth: '360px' }}
            type="number"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>
            }}
            variant="standard"
            allowDecimal={true}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'advanced-search') {
      const searchValues = column.searchInfo.searchingRows;
      let nameKey = '';
      if (searchValues) {
        const selectedValue = searchValues.find(s => s[column.accessorKey] === values[column.accessorKey]);
        if (selectedValue) {
          nameKey = selectedValue[column.nameKey];
        }
      }
      return (
        <div>
          <FormControl sx={{ marginTop: '6px', width: '100%' }}>
            <AdvancedSearch
              labelText={column.header}
              displayValueAccessorKey={column.searchInfo.nameKey}
              saveIdValueAccessorKey={column.searchInfo.idKey}
              searchingCriteria={column.searchInfo.searchingColumns}
              searchingCriteriaExtensions={column.searchInfo.searchingColumnExtensions}
              searchingRows={column.searchInfo.searchingRows}
              id={values[column.accessorKey]}
              value={nameKey}
              setIdValue={(id, value) => {
                setValues({ ...values, [column.nameKey]: value, [column.accessorKey]: id });
              }}
              maxWidthsx={'360px'}
              required={column.required}
              variant="standard"
            />
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'file') {
      return (
        <div>
          <div>{values[column.accessorKey] ? `${column.header} (Selected File: ${values[column.accessorKey]})` : column.header}</div>
          <TextField
            key={column.accessorKey}
            name={column.accessorKey}
            required={column.required}
            disabled={column.disabled}
            margin="dense"
            sx={{ maxWidth: '360px' }}
            variant="standard"
            type="file"
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-row-form') {
      return (
        <div>
          <MultiRowForm
            formValues={
              values[column.accessorKey] && values[column.accessorKey].length > 0
                ? values[column.accessorKey].map(item => ({ ...item }))
                : []
            }
            saveFunction={newValues => setValues({ ...values, [column.accessorKey]: newValues })}
            formFields={column.formFields}
            createNewRowFunc={column.createNewRowFunc}
            formLabel={column.formLabel}
            addRowLabel={column.addRowLabel}
            header={column.header}
            addButtons={column.addButtons}
            parentValues={values}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if(column.type === 'multi-row-form') {
      return (
        <div>
          <MultiRowForm
            formValues={values[column.accessorKey] && values[column.accessorKey].length > 0 ? values[column.accessorKey].map(item => ({ ...item })) : []}
            saveFunction={(newValues) => setValues({ ...values, [column.accessorKey]: newValues })}
            formFields={column.formFields}
            createNewRowFunc={column.createNewRowFunc}
            formLabel={column.formLabel}
            addRowLabel={column.addRowLabel}
            header={column.header}
            addButtons={column.addButtons}
            parentValues={values}
          />
        </div>
      )
    }
  };

  const filterVisibleColumns = columns => {
    return columns.filter(column => !column.hideInModel);
  };

  let visibleColumns = filterVisibleColumns(columns);
  let notesGroup = visibleColumns.filter(
    column => column.type === 'notes' || column.type === 'multi-row-form' || column.type === 'googleAddressSearch'
  );
  let addedModifiedGroup = visibleColumns.filter(
    column => column.type !== 'notes' && (column.accessorKey.includes('added') || column.accessorKey.includes('modified'))
  );
  let remainingColumns = visibleColumns.filter(column => {
    // Existing filters
    if (
      column.type === 'notes' ||
      column.type === 'multi-row-form' ||
      column.type === 'googleAddressSearch' ||
      column.accessorKey.includes('added') ||
      column.accessorKey.includes('modified')
    ) {
      return false;
    }

    const shouldRenderColumn = (column, category, values) => {
      if (column.displayDependent) {
        const dependentValue = values[column.displayDependent];
        const expectedValue = column.displayDependentVal;

        let shouldShow = false;

        if (Array.isArray(expectedValue)) {
          shouldShow = expectedValue.includes(dependentValue);
        } else {
          shouldShow = dependentValue === expectedValue || dependentValue === true;
        }

        if (!shouldShow) {
          return false;
        }
      }

      if (category.conditionalRender) {
        const categoryValue = values[column.categoryType];

        if (categoryValue === true) {
          if (column.dependentOn) {
            return values[column.dependentOn] === column.dependentValue;
          }
          return true;
        } else {
          return column.conditional === true;
        }
      }

      if (column.dependentOn) {
        return values[column.dependentOn] === column.dependentValue;
      }

      return true;
    };

    const category = categories?.find(cat => cat.title === column.categoryType);
    if (category) {
      return shouldRenderColumn(column, category, values);
    }

    return true;
  });

  let rows = chunkColumns(remainingColumns, 3);

  const handleSubmit = async e => {
    //put your validation logic here
    // need to add 'modified on / by' logic here
    e.preventDefault();
    await onSubmit(onClose, row, values);
  };

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'lg'}>
      <form onSubmit={handleSubmit} fullScreen>
        <DialogTitle textAlign="center">Edit</DialogTitle>
        <fieldset disabled={hideEdit} style={{ border: 0, margin: 0, padding: 0 }}>
          <div className={classes.dialogContentContainer}>
            <Stack
              sx={{
                width: '100%',
                minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
                gap: '1.5rem'
              }}
            >
            {rows.map((row, rowIndex) => (
              <Grid container spacing={2} key={`row-${rowIndex}`}>
                {categories &&
                  categories.length > 0 &&
                  categories.map((category, categoryIndex) => (
                    <Grid container item spacing={2} key={`row-${rowIndex}-category-${categoryIndex}`}>
                      {row.map((column, colIndex) => {
                        // if there's a category, let's render in an order based on category
                        if (column.categoryType && column.categoryType === category.title) {
                          // if there is a 'dependent on' dropdown (i.e specifically for TRC Booking in AUTH TRIPS), display if true
                          let inList =
                            column.displayDependentVal && Array.isArray(column.displayDependentVal)
                              ? column.displayDependentVal.includes(values[column.displayDependent])
                              : false;
                          if (
                            column.displayDependent &&
                            (values[column.displayDependent] === column.displayDependentVal ||
                              values[column.displayDependent] === true ||
                              inList)
                          ) {
                            // if there is a section to be conditionally rendered, display if true
                            if (category.conditionalRender && values[column.categoryType] === true) {
                              // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                              if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                return (
                                  <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                    {renderInput(column, rowIndex * colIndex)}
                                  </Grid>
                                );
                              } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                return null;
                              } else {
                                return (
                                  <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                    {renderInput(column, rowIndex * colIndex)}
                                  </Grid>
                                );
                              }
                            }
                            // if there is a section to be conditionally rendered, but value doesn't match, check for -
                            else if (category.conditionalRender && values[column.categoryType] !== true) {
                              // if the column is the value that renders the conditional, make sure to still display it
                              if (column.conditional) {
                                return (
                                  <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                    {renderInput(column, rowIndex * colIndex)}
                                  </Grid>
                                );
                              } else {
                                return;
                              }
                            } else {
                              // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                              if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                return (
                                  <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                    {renderInput(column, rowIndex * colIndex)}
                                  </Grid>
                                );
                              } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                return;
                              } else {
                                return (
                                  <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                    {renderInput(column, rowIndex * colIndex)}
                                  </Grid>
                                );
                              }
                            }
                          } else {
                            if (column.displayDependent && values[column.displayDependent] !== column.displayDependentVal) {
                              return null;
                            } else {
                              // if there is a section to be conditionally rendered, display if true
                              if (category.conditionalRender && values[column.categoryType] === true) {
                                // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                                if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                  return null;
                                } else {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                }
                              }
                              // if there is a section to be conditionally rendered, but value doesn't match, check for -
                              else if (category.conditionalRender && values[column.categoryType] !== true) {
                                // if the column is the value that renders the conditional, make sure to still display it
                                if (column.conditional) {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                } else {
                                  return null;
                                }
                              } else {
                                // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                                if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                  return null;
                                } else {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                }
                              }
                            }
                          }
                        }
                      })}
                    </Grid>
                  ))}
              </Grid>
            ))}

            {categories === null && (
              <Grid container spacing={2} direction="column">
                {rows.map((row, rowIndex) => (
                  <Grid container item spacing={2} key={rowIndex}>
                    {row.map((column, colIndex) => {
                      // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                      if (column.dependentOn) {
                        if (values[column.dependentOn] === column.dependentValue) {
                          return (
                            <Grid item xs={4} key={column.accessorKey}>
                              {renderInput(column, rowIndex * colIndex)}
                            </Grid>
                          );
                        } else {
                          return null;
                        }
                      } else {
                        return (
                          <Grid item xs={4} key={column.accessorKey}>
                            {renderInput(column, rowIndex * colIndex)}
                          </Grid>
                        );
                      }
                    })}
                  </Grid>
                ))}
              </Grid>
            )}

            <div className={classes.editModalContainer}>
              <div className={classes.editModalColumn}>
                {notesGroup.map(column => {
                  if (column.dependentOn) {
                    if (values[column.dependentOn] === column.dependentValue) {
                      return renderInput(column);
                    } else {
                      return;
                    }
                  } else {
                    return renderInput(column);
                  }
                })}
              </div>
            </div>
            <div className={classes.editModalContainer}>
              <div className={classes.editModalColumn}>
                {addedModifiedGroup.map(column => {
                  return renderInput(column);
                })}
              </div>
            </div>
            </Stack>
          </div>
        </fieldset>
        {isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Spinner />
          </DialogActions>
        )}
        {!isLoading && !hideEdit && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              disabled={isDirtyLogic !== null && isDirtyLogic(values[isDirtyField])}
              color="secondary"
              type="submit"
              variant="contained"
            >
              Save
            </Button>
          </DialogActions>
        )}
        {!isLoading && hideEdit && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        )}
      </form>
    </Dialog>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ classes, open, columns, onClose, onSubmit, isLoading, categories, isDirtyLogic, isDirtyField }) => {
  const [values, setValues] = useState({});

  useEffect(() => {
    if (open) {
      setValues(
        columns.reduce((acc, column) => {
          acc[column.accessorKey ?? ''] = column.defaultVal != null ? column.defaultVal : '';
          if (column.nameKey) acc[column.nameKey] = column.defaultName != null ? column.defaultName : '';
          if (column.type === 'checkbox') {
            acc[column.accessorKey ?? ''] = column.defaultVal != null ? column.defaultVal : false;
          }
          return acc;
        }, {})
      );
    }
  }, [open, columns]);

  useComputedColumnValues(columns, values, setValues);

  const handleDropdownChange = (e, accessorKey) => {
    setValues(prevValues => ({
      ...prevValues,
      [accessorKey]: e.target.value
    }));
  };

  const parseValueToArray = input => {
    if (!input) return [];
    return Array.isArray(input) ? input : input.split(',');
  };

  const renderStateOptions = memoize(() => {
    const useCountryCode = countryCode || 'USA';
    let allStates = states.filter(state => state.countryCode === useCountryCode).map(state => state);
    return allStates;
  });

  const renderCountryOptions = memoize(() => {
    let allCountries = countries.map(country => country);
    return allCountries;
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryCode, setCountryCode] = useState(values && values.length > 0 ? values['country'] : '');

  const renderInput = (column, index) => {
    if (column?.hideInModel === true || (column.shouldHideField != null && column.shouldHideField(values))) {
      return null;
    }
    if (column.type === 'hidden') {
      return <div></div>;
    }
    if (column.type === 'title') {
      return (
        <div style={{ marginBottom: '16px' }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              marginBottom: '8px'
            }}
          >
            {column.header}
          </Typography>
          <Divider sx={{ marginBottom: '16px' }} />
        </div>
      );
    }
    if (column.type === 'text') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey]}
            disabled={column.accessorKey === 'fieldId' ? true: column.disabled}
            margin="dense"
            variant="standard"
            sx={{ width: '360px' }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.hint && (
            <Typography variant="caption" display="block" color="text.secondary" sx={{ marginTop: '4px' }}>
              {column.hint}
            </Typography>
          )}
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'notes') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            disabled={column.disabled}
            margin="dense"
            multiline
            rows={4}
            sx={{ width: '1100px' }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            variant="standard"
          />
           {column.hint && (
            <Typography variant="caption" display="block" color="text.secondary" sx={{ marginTop: '4px' }}>
              {column.hint}
            </Typography>
          )}
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }

    if (column.type === 'number') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            margin="dense"
            disabled={column.disabled}
            sx={{ width: '360px' }}
            type="number"
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            variant="standard"
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'googleAddressSearch') {
      return (
        <div>
          <GoogleAddressSearch
            address={values[column.accessorKey]}
            provinces={column.provinces}
            countries={column.countries}
            classes={classes}
            onChange={e => {
              setValues({ ...values, [column.accessorKey]: e });
            }}
          />
        </div>
      );
    }
        if(column.type === 'googleAddressSearch') {
          return (  
            <div>
              <GoogleAddressSearch 
                address={values[column.accessorKey]}
                provinces={column.provinces}
                countries={column.countries}
                classes={classes}
                onChange={e => {
                  setValues({ ...values, [column.accessorKey]: e });
                }}
              />
            </div>
          )
        }
    if (column.type === 'dropdown') {
      return (
        <div>
          <FormControl key={index}>
            <InputLabel sx={{ marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              disabled={column.disabled}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              margin="dense"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => handleDropdownChange(e, column.accessorKey)}
              value={values[column.accessorKey]}
              variant="standard"
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'dropdown-bool') {
      if (values[column.accessorKey] !== undefined) {
        let convertedValue = '';
        if (values[column.accessorKey] === true) {
          convertedValue = column.options[0];
        } else if (values[column.accessorKey] === false) {
          convertedValue = column.options[1];
        } else {
          convertedValue = values[column.accessorKey];
        }
        return (
          <div>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
                {column.header}
              </InputLabel>
              <Select
                labelId={column.header}
                key={column.accessorKey}
                label={column.header}
                name={column.accessorKey}
                required={column.required}
                disabled={column.disabled}
                value={convertedValue}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
                onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
              >
                {column.options.map(opt => (
                  <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {column.required && (
              <>
                <Typography variant="caption" display="block" color="primary">
                  Required
                </Typography>
              </>
            )}
          </div>
        );
      } else {
        let convertedValue = '';
        if (values[column.accessorKey] === true) {
          convertedValue = column.options[0];
        } else if (values[column.accessorKey] === false) {
          convertedValue = column.options[1];
        } else {
          convertedValue = values[column.accessorKey];
        }
        return (
          <div>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
                {column.header}
              </InputLabel>
              <Select
                labelId={column.header}
                key={column.accessorKey}
                label={column.header}
                name={column.accessorKey}
                required={column.required}
                disabled={column.disabled}
                value={convertedValue}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
                onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
              >
                {column.options.map(opt => (
                  <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {column.required && (
              <>
                <Typography variant="caption" display="block" color="primary">
                  Required
                </Typography>
              </>
            )}
          </div>
        );
      }
    }
    if (column.type === 'dropdown-v2') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              disabled={column.disabled || (!!column.parentField && !values[column.parentField])}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              margin="dense"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              value={values[column.accessorKey]}
              onChange={e => setValues(setValueAndClearDependents(columns, values, e.target.name, e.target.value))}
              variant="standard"
            >
              {getDependentOptions(column, values).map(opt => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'country') {
      let countryOptions = renderCountryOptions();
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={values[column.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => {
                setValues({ ...values, [e.target.name]: e.target.value });
                setCountryCode(values['country']);
              }}
            >
              {countryOptions.map(opt => (
                <MenuItem key={opt.countryCode} value={opt.countryCode} sx={{ margin: 'dense' }}>
                  {opt.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'state') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={values[column.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {renderStateOptions().map(opt => (
                <MenuItem key={opt.code} value={opt.code} sx={{ margin: 'dense' }}>
                  {opt.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-select') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={parseValueToArray(values[column.accessorKey])}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(value => (
                    <Chip
                      key={value}
                      label={value}
                      onDelete={() => {
                        const updatedValues = values[column.accessorKey].filter(v => v !== value);
                        setValues({ ...values, [column.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-select-v2') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={values[column.accessorKey] || []}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => {
                setValues({
                  ...values,
                  [column.accessorKey]: e.target.value
                });
              }}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(option => (
                    <Chip
                      key={option.id}
                      label={option.title}
                      onDelete={() => {
                        const updatedValues = values[column.accessorKey].filter(v => v.id !== option.id);
                        setValues({ ...values, [column.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
            >
              {column.options.map(opt => (
                <MenuItem key={opt.id} value={opt} sx={{ margin: 'dense' }}>
                  {opt.title} {/* Display name */}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'country') {
      let countryOptions = renderCountryOptions();
      return (
        <div>
        <FormControl sx={{ marginTop: '6px' }}>
          <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
            {column.header}
          </InputLabel>
          <Select
            labelId={column.header}
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            disabled={column.disabled}
            value={values[column.accessorKey]}
            margin="dense"
            variant="standard"
            sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
            onChange={(e) => {setValues({ ...values, [e.target.name]: e.target.value }); setCountryCode(values['country'])}}
          >
            { countryOptions.map((opt) => (
              <MenuItem key={opt.countryCode} value={opt.countryCode} sx={{ margin: 'dense' }}>
                {opt.description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'state') {
      return (
        <div>
        <FormControl sx={{ marginTop: '6px' }}>
          <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
            {column.header}
          </InputLabel>
          <Select
            labelId={column.header}
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            disabled={column.disabled}
            value={values[column.accessorKey]}
            margin="dense"
            variant="standard"
            sx={{ marginTop: '6px', marginBottom: '6px', width: '360px' }}
            onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
          >
            { renderStateOptions().map((opt) => (
              <MenuItem key={opt.code} value={opt.code} sx={{ margin: 'dense' }}>
                {opt.description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-select') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              required={column.required}
              disabled={column.disabled}
              value={parseValueToArray(values[column.accessorKey])}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(value => (
                    <Chip
                      key={value}
                      label={value}
                      onDelete={() => {
                        const updatedValues = values[column.accessorKey].filter(v => v !== value);
                        setValues({ ...values, [column.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-select-v2') {
          return (
            <div>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
                  {column.header}
                </InputLabel>
                <Select
                  labelId={column.header}
                  key={column.accessorKey}
                  label={column.header}
                  name={column.accessorKey}
                  required={column.required}
                  disabled={column.disabled}
                  value={values[column.accessorKey] || []}
                  multiple
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
                  onChange={e => {
                    setValues({
                      ...values,
                      [column.accessorKey]: e.target.value
                    });
                  }}
                  renderValue={selected => (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '4px'
                      }}
                    >
                      {selected.map(option => (
                        <Chip
                          key={option.id}
                          label={option.title}
                          onDelete={() => {
                            const updatedValues = values[column.accessorKey].filter(v => v.id !== option.id);
                            setValues({ ...values, [column.accessorKey]: updatedValues });
                          }}
                          onMouseDown={e => {
                            e.stopPropagation();
                          }}
                        />
                      ))}
                    </div>
                  )}
                >
                  {column.options.map(opt => (
                    <MenuItem key={opt.id} value={opt} sx={{ margin: 'dense' }}>
                      {opt.title} {/* Display name */}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {column.required && (
                <Typography variant="caption" display="block" color="primary">
                  Required
                </Typography>
              )}
            </div>
          );
        }
    if (column.type === 'date') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            disabled={column.disabled}
            name={column.accessorKey}
            required={column.required}
            sx={{ width: '360px' }}
            margin="dense"
            type="date"
            InputLabelProps={{ shrink: true }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            variant="standard"
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'checkbox') {
      return (
        <div>
          <FormControl sx={{ marginTop: '20px', marginBottom: '5px', marginRight: '200px' }} key={index}>
            <FormControlLabel
              key={column.accessorKey}
              name={column.accessorKey}
              label={column.header}
              labelPlacement="start"
              control={<Checkbox />}
              required={column.required}
              disabled={column.disabled}
              checked={values[column.accessorKey] != null ? values[column.accessorKey] : false}
              variant="standard"
              margin="dense"
              sx={{ marginTop: '6px' }}
              onClick={e => setValues({ ...values, [e.target.name]: e.target.checked })}
            />
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'money') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey]}
            margin="dense"
            disabled={column.disabled}
            sx={{ maxWidth: '360px' }}
            type="number"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>
            }}
            allowDecimal={true}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            variant="standard"
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'advanced-search') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px', width: '100%' }} key={index}>
            <AdvancedSearch
              key={column.accessorKey}
              labelText={column.header}
              displayValueAccessorKey={column.searchInfo.nameKey}
              saveIdValueAccessorKey={column.searchInfo.idKey}
              searchingCriteria={column.searchInfo.searchingColumns}
              searchingCriteriaExtensions={column.searchInfo.searchingColumnExtensions}
              searchingRows={column.searchInfo.searchingRows}
              id={values[column.accessorKey]}
              value={values[column.nameKey]}
              setIdValue={(id, value) => {
                setValues({ ...values, [column.nameKey]: value, [column.accessorKey]: id });
              }}
              maxWidthsx={'360px'}
              required={column.required}
              variant="standard"
            />
          </FormControl>
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'file') {
      return (
        <div>
          <div>{values[column.accessorKey] ? `${column.header} (Selected File: ${values[column.accessorKey]})` : column.header}</div>
          <TextField
            key={column.accessorKey}
            name={column.accessorKey}
            required={column.required}
            disabled={column.disabled}
            margin="dense"
            sx={{ maxWidth: '360px' }}
            variant="standard"
            type="file"
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (column.type === 'multi-row-form') {
      return (
        <div>
          <MultiRowForm
            formValues={
              values[column.accessorKey] && values[column.accessorKey].length > 0
                ? values[column.accessorKey].map(item => ({ ...item }))
                : []
            }
            saveFunction={newValues => setValues({ ...values, [column.accessorKey]: newValues })}
            formFields={column.formFields}
            createNewRowFunc={column.createNewRowFunc}
            formLabel={column.formLabel}
            addRowLabel={column.addRowLabel}
            header={column.header}
            addButtons={column.addButtons}
            parentValues={values}
          />
          {column.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if(column.type === 'multi-row-form') {
      return (
        <div>
          <MultiRowForm
            formValues={values[column.accessorKey] && values[column.accessorKey].length > 0 ? values[column.accessorKey].map(item => ({ ...item })) : []}
            saveFunction={(newValues) => setValues({ ...values, [column.accessorKey]: newValues })}
            formFields={column.formFields}
            createNewRowFunc={column.createNewRowFunc}
            formLabel={column.formLabel}
            addRowLabel={column.addRowLabel}
            header={column.header}
            addButtons={column.addButtons}
            parentValues={values}
          />
        </div>
      )
    }
  };

  const handleSubmit = async e => {
    //put your validation logic here
    // need to add 'added on / by' logic here
    e.preventDefault();
    setIsSubmitting(true);
    const saved = await onSubmit(values);
    setIsSubmitting(false);
    if (saved) onClose();
  };

  const filterVisibleColumns = columns => {
    return columns.filter(column => !column.hideInModel);
  };

  let visibleColumns = filterVisibleColumns(columns);
  let notesGroup = visibleColumns.filter(
    column => column.type === 'notes' || column.type === 'multi-row-form' || column.type === 'googleAddressSearch'
  );
  let addedModifiedGroup = visibleColumns.filter(
    column => column.type !== 'notes' && (column.accessorKey.includes('added') || column.accessorKey.includes('modified'))
  );
  let remainingColumns = visibleColumns.filter(column => {
    // Existing filters
    if (
      column.type === 'notes' ||
      column.type === 'multi-row-form' ||
      column.type === 'googleAddressSearch' ||
      column.accessorKey.includes('added') ||
      column.accessorKey.includes('modified')
    ) {
      return false;
    }

    const shouldRenderColumn = (column, category, values) => {
      if (column.displayDependent) {
        const dependentValue = values[column.displayDependent];
        const expectedValue = column.displayDependentVal;

        let shouldShow = false;

        if (Array.isArray(expectedValue)) {
          shouldShow = expectedValue.includes(dependentValue);
        } else {
          shouldShow = dependentValue === expectedValue || dependentValue === true;
        }

        if (!shouldShow) {
          return false;
        }
      }

      if (category.conditionalRender) {
        const categoryValue = values[column.categoryType];

        if (categoryValue === true) {
          if (column.dependentOn) {
            return values[column.dependentOn] === column.dependentValue;
          }
          return true;
        } else {
          return column.conditional === true;
        }
      }

      if (column.dependentOn) {
        return values[column.dependentOn] === column.dependentValue;
      }

      return true;
    };

    const category = categories?.find(cat => cat.title === column.categoryType);
    if (category) {
      return shouldRenderColumn(column, category, values);
    }

    return true;
  });

  let rows = chunkColumns(remainingColumns, 3);

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'lg'}>
      <form onSubmit={handleSubmit}>
        <DialogTitle textAlign="center">Add Record</DialogTitle>
        <div className={classes.dialogContentContainer}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
              gap: '1.5rem',
              padding: '20px'
            }}
          >
            <Grid container spacing={2} direction="column">
              {rows.map((row, rowIndex) => (
                <Grid container item spacing={2} key={`row-${rowIndex}`}>
                  {categories &&
                    categories.length > 0 &&
                    categories.map((category, categoryIndex) => (
                      <Grid container item spacing={2} key={`category-${rowIndex}-${categoryIndex}`}>
                        {row.map((column, colIndex) => {
                          // if there's a category, let's render in an order based on category
                          if (column.categoryType && column.categoryType === category.title) {
                            // if there is a 'dependent on' dropdown (i.e specifically for TRC Booking in AUTH TRIPS), display if true
                            let inList =
                              column.displayDependentVal && Array.isArray(column.displayDependentVal)
                                ? column.displayDependentVal.includes(values[column.displayDependent])
                                : false;
                            if (
                              column.displayDependent &&
                              (values[column.displayDependent] === column.displayDependentVal ||
                                values[column.displayDependent] === true ||
                                inList)
                            ) {
                              // if there is a section to be conditionally rendered, display if true
                              if (category.conditionalRender && values[column.categoryType] === true) {
                                // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                                if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                  return;
                                } else {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                }
                              }
                              // if there is a section to be conditionally rendered, but value doesn't match, check for -
                              else if (category.conditionalRender && values[column.categoryType] !== true) {
                                // if the column is the value that renders the conditional, make sure to still display it
                                if (column.conditional) {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                } else {
                                  return;
                                }
                              } else {
                                // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                                if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                } else {
                                  return (
                                    <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                      {renderInput(column, rowIndex * colIndex)}
                                    </Grid>
                                  );
                                }
                              }
                            } else {
                              if (column.displayDependent && values[column.displayDependent] !== column.displayDependentVal) {
                                return;
                              } else {
                                // if there is a section to be conditionally rendered, display if true
                                if (category.conditionalRender && values[column.categoryType] === true) {
                                  // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                                  if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                    return (
                                      <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                        {renderInput(column, rowIndex * colIndex)}
                                      </Grid>
                                    );
                                  } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                    return;
                                  } else {
                                    return (
                                      <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                        {renderInput(column, rowIndex * colIndex)}
                                      </Grid>
                                    );
                                  }
                                }
                                // if there is a section to be conditionally rendered, but value doesn't match, check for -
                                else if (category.conditionalRender && values[column.categoryType] !== true) {
                                  // if the column is the value that renders the conditional, make sure to still display it
                                  if (column.conditional) {
                                    return (
                                      <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                        {renderInput(column, rowIndex * colIndex)}
                                      </Grid>
                                    );
                                  } else {
                                    return;
                                  }
                                } else {
                                  // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                                  if (column.dependentOn && values[column.dependentOn] === column.dependentValue) {
                                    return (
                                      <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                        {renderInput(column, rowIndex * colIndex)}
                                      </Grid>
                                    );
                                  } else if (column.dependentOn && values[column.dependentOn] !== column.dependentValue) {
                                    return;
                                  } else {
                                    return (
                                      <Grid item xs={column.gridSize || 4} key={column.accessorKey}>
                                        {renderInput(column, rowIndex * colIndex)}
                                      </Grid>
                                    );
                                  }
                                }
                              }
                            }
                          }
                        })}
                      </Grid>
                    ))}
                </Grid>
              ))}
              {categories === null && (
                <Grid container spacing={2} direction="column">
                  {rows.map((row, rowIndex) => (
                    <Grid container item spacing={2} key={rowIndex}>
                      {row.map((column, colIndex) => {
                        // if a field's display is depended on 1 OTHER FIELD VALUE, display if true:
                        if (column.dependentOn) {
                          if (values[column.dependentOn] === column.dependentValue) {
                            return (
                              <Grid item xs={4} key={column.accessorKey}>
                                {renderInput(column, rowIndex * colIndex)}
                              </Grid>
                            );
                          } else {
                            return;
                          }
                        } else {
                          return (
                            <Grid item xs={4} key={column.accessorKey}>
                              {renderInput(column, rowIndex * colIndex)}
                            </Grid>
                          );
                        }
                      })}
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
            <div className={classes.editModalContainer}>
              <div className={classes.editModalColumn}>
                {notesGroup.map((column, index) => {
                  if (column.dependentOn) {
                    if (values[column.dependentOn] === column.dependentValue) {
                      return renderInput(column);
                    } else {
                      return;
                    }
                  } else {
                    return renderInput(column);
                  }
                })}
              </div>
            </div>
            <div className={classes.editModalContainer}>
              <div className={classes.editModalColumn}>
                {addedModifiedGroup.map((column, index) => {
                  return renderInput(column, index);
                })}
              </div>
            </div>
          </Stack>
        </div>
        {isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Spinner />
          </DialogActions>
        )}
        {!isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              disabled={isDirtyLogic !== null ? isDirtyLogic(values[isDirtyField]) : isSubmitting}
              color="secondary"
              type="submit"
              variant="contained"
            >
              Add Record
            </Button>
          </DialogActions>
        )}
      </form>
    </Dialog>
  );
};

export default compose(
  withStyles(styles),
  connect(null, {
    showToast
  })
)(CrudTable);
